import { apiClient } from '.';

// 스터디 카테고리 관련 타입 정의
export interface StudyCategory {
  id: number;
  name: string;
}

export interface StudyCategoryApiResponse {
  code: number;
  status: string;
  message: string;
  data: StudyCategory[];
}

// 스터디 카테고리 목록 조회
export const getStudyCategoriesList = async (): Promise<StudyCategoryApiResponse> => {
  try {
    console.log('스터디 카테고리 목록 조회 API 호출');
    
    const { data: result } = await apiClient.get<StudyCategoryApiResponse>(
      '/api/study-categories/list',
      { withCredentials: true }
    );
    
    console.log('스터디 카테고리 API 응답:', result);
    
    if (result.code !== 200) {
      throw new Error(`API error: ${result.message}`);
    }

    return result;
  } catch (error) {
    console.error('스터디 카테고리 목록 조회 실패:', error);
    throw error;
  }
};
